import { isSafari } from "react-device-detect";

export default class DeviceManager {
  private static instance?: DeviceManager;

  static getInstance(): DeviceManager {
    if (!this.instance) {
      this.instance = new DeviceManager();
    }
    return this.instance;
  }

  // eslint-disable-next-line sonarjs/public-static-readonly -- Disabled for plugin version update. Fix when possible
  static userMediaPromiseMap: Map<MediaDeviceKind, Promise<MediaStream>> =
    new Map();

  async getDevices(kind?: MediaDeviceKind): Promise<MediaDeviceInfo[]> {
    if (DeviceManager.userMediaPromiseMap?.size > 0) {
      try {
        if (kind) {
          await DeviceManager.userMediaPromiseMap.get(kind);
        } else {
          await Promise.all(DeviceManager.userMediaPromiseMap.values());
        }
      } catch {
        console.warn("error waiting for media permissions");
      }
    }
    let devices = await navigator.mediaDevices.enumerateDevices();

    if (!(isSafari && this.hasDeviceInUse(kind))) {
      devices = await this.acquireDevicePermissions(devices, kind);
    }

    if (kind) {
      devices = devices.filter(device => device.kind === kind);
    }
    return devices;
  }

  private async acquireDevicePermissions(
    devices: MediaDeviceInfo[],
    kind?: MediaDeviceKind,
  ): Promise<MediaDeviceInfo[]> {
    let newDevices: MediaDeviceInfo[] = devices;

    const isDummyDeviceOrEmpty =
      devices.filter(d => d.kind === kind).length === 0 ||
      devices.some(device => {
        const hasBlankLabel = device.label === "";
        const isRelevant = kind ? device.kind === kind : true;
        return hasBlankLabel && isRelevant;
      });

    if (isDummyDeviceOrEmpty) {
      const permissionsToAcquire: MediaStreamConstraints = {
        video: kind !== "audioinput" && kind !== "audiooutput",
        audio: kind !== "videoinput" && { deviceId: { ideal: "default" } },
      };
      const stream =
        await navigator.mediaDevices.getUserMedia(permissionsToAcquire);
      newDevices = await navigator.mediaDevices.enumerateDevices();
      stream.getTracks().forEach(track => {
        track.stop();
      });
    }

    return newDevices;
  }

  private hasDeviceInUse(kind?: MediaDeviceKind): boolean {
    return kind
      ? DeviceManager.userMediaPromiseMap.has(kind)
      : DeviceManager.userMediaPromiseMap.size > 0;
  }
}
